module.exports = __webpack_public_path__ + "img/pt-BR.34fc379a.svg";